export const selectOptionsLoanPurpose = [
  // "Delayed Purchase",
  "Purchase",
  "Refinance - No Cash Out",
  "Refinance - Cash Out",
];
